export default "__VITE_ASSET__m4kdQV17__ 120w, __VITE_ASSET__N1pN0BlG__ 240w, __VITE_ASSET__Dtf1NI3x__ 480w";